import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Login from './routes/login';
import App from './App';
import CircularProgress from '@material-ui/core/CircularProgress';
import { validateToken } from './actions/authActions';

class AuthOrApp extends Component {
    componentWillMount() {
        let { user } = this.props.auth;
        if(user)
            this.props.validateToken(user.token);
    }
    
    render() {
        const { user, validToken } = this.props.auth;

        if (user && validToken) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;
            return <App>{this.props.children}</App>
        } else if (!user && !validToken) {
            return <Login />
        } else {
            return (
                <div style={{display:'flex',flex:1, justifyContent:'center', alignItems:'center', height:'100%'}} >
                    <CircularProgress  size={50} />
                </div>
            );
        }

    }
}


const mapStateToProps = (state) => ({
    auth: state.authReducer
})


const mapDispatchToProps = {
    validateToken
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthOrApp)






// WEBPACK FOOTER //
// ./src/AuthOrApp.js